import { useEffect, useState } from 'react';

const useContentLoaded = (dependencies = []) => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);

  useEffect(() => {
    const checkContentLoaded = () => {
      // Check if main content elements are present
      const mainContent = document.querySelector('.App');
      const header = document.querySelector('header');
      const routes = document.querySelector('[data-testid="routes"]') || document.querySelector('main');
      
      // For category pages, check for category-specific content using a valid selector
      const categoryContent = document.querySelector('[class*="bg-"]') || document.querySelector('.bg-white') || document.querySelector('[style*="background-color"]');
      
      const hasMainContent = mainContent && mainContent.children.length > 0;
      const hasHeader = header && header.children.length > 0;
      const hasRoutes = routes && routes.children.length > 0;
      const hasCategoryContent = categoryContent && categoryContent.children.length > 0;
      
      // Content is considered loaded if we have main content and either routes or category content
      const isLoaded = hasMainContent && (hasRoutes || hasCategoryContent);
      
      if (isLoaded) {
        setIsContentLoaded(true);
      } else {
        // If not loaded, check again immediately for faster response
        requestAnimationFrame(checkContentLoaded);
      }
    };

    // Start checking immediately
    checkContentLoaded();
    
    return () => {
      // Cleanup if needed
    };
  }, dependencies);

  return isContentLoaded;
};

export default useContentLoaded;
